/** The color of the amblient lightning, the rays around the wheel */
export const wheelAmbientModeLightColor = "hsla(30, 100%, 73%, 0.388)"

/** Between the frame of the wheel containing the lightbulbs and the rotating part there are 2 circular borders, each 1 px thick */
export const wheelGoldBorder = "#e0d4be";
export const wheelDarkBorder = "hsl(30, 14%, 1%)";
/** The slices of the wheel have different color. lighter and darker */
export const wheelSliceLight = "#f0e2ba";
export const wheelSliceDark = "#dfc38f";
export const lineBetweenSlicesColor = "#9c9a9532";
// 
export const wheelBrownBorder = "#89736b";
//
export const wheelBoxShadowInset = "hsla(30, 69%, 40%, 0.82)";

/** base color for all light bulbs. Some of them are overriden */
export const bulbClassicLightBg = "hsl(30, 86%, 57%)";
